import type { ReactNode } from 'react';
import { useCanAccessPermission } from '@/shared/model/adminAccess';

interface PermissionGateProps {
    permission: string;
    children: ReactNode;
}

/** Показывает содержимое при доступном прикладном праве */
export const PermissionGate = ({ permission, children }: PermissionGateProps) => (
    useCanAccessPermission(permission)
        ? <>{children}</>
        : null
);
